import { Formik } from 'formik'
import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { AirspaceSelectCityFormValues } from './AirspaceSelectCityForm.interface'
import { AirspaceSelectCityFormSchema } from './AirspaceSelectCityForm.validator'
import { FormErrorMessage } from 'src/components/shared/form/FormErrorMessage'
import tw from 'twin.macro'
import { FormikSelect } from 'src/components/shared/form/formik/FormikSelect'
import citiesConfig from './citiesConfig.json'
import { useQuery } from 'src/utils/hooks/useQuery'
import { Button } from 'src/components/shared/Button'

const initialValues: AirspaceSelectCityFormValues = {
  city: '',
}

const BGC_MVR_FLOW = 'BGC_MVR'

export const AirspaceSelectCityForm = () => {
  const navigate = useNavigate()

  const { getQuery } = useQuery()

  const flow = getQuery('flow')

  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [error, setError] = useState<string | null>(null)

  const handleFormSubmit = async ({ city }: AirspaceSelectCityFormValues) => {
    setIsLoading(true)
    setError(null)

    const cityValue = city.split('_')[0]

    const template = citiesConfig.optionTemplates.find((item) => item.values.includes(cityValue))

    if (!template) {
      return
    }

    const onboardingTemplateId =
      flow === BGC_MVR_FLOW ? template.bgcMvrOnboardingTemplateId : template.onboardingTemplateId

    navigate(
      `/client/airspace/sign-up?partnerMarketId=${citiesConfig.partnerMarketId}&onboardingTemplateId=${onboardingTemplateId}&tags=${cityValue}`,
    )
  }

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={handleFormSubmit}
      validationSchema={AirspaceSelectCityFormSchema}
    >
      {({ handleSubmit }) => (
        <div>
          <div css={tw`w-full mb-4`}>
            <FormikSelect
              name="city"
              label="Which city and state will you be driving in?"
              placeholder="Select your city and state"
              options={citiesConfig.options.map((item) => ({
                label: item.label,
                value: `${item.value}_${item.label}`,
              }))}
              inputProps={{ 'data-testid': 'pre-onboarding-airspace-city-input' }}
            />
          </div>
          <FormErrorMessage css={tw`mb-4`} error={error} />
          <Button
            className={tw`w-full`}
            loading={isLoading}
            onClick={() => handleSubmit()}
            data-testid="pre-onboarding-airspace-continue-btn"
          >
            Continue
          </Button>
        </div>
      )}
    </Formik>
  )
}
